<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-download`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38.615 18.608C37.077 11.958 31.117 7 24 7S10.923 11.957 9.385 18.608C5.085 20.103 2 24.19 2 29c0 6.075 4.925 11 11 11v-4a7 7 0 110-14l.004-.288C13.157 15.77 18.02 11 24 11l.288.004C30.23 11.157 35 16.02 35 22h.048l.193.004A7 7 0 0136 35.93v4.026C41.607 39.45 46 34.738 46 29c0-4.809-3.086-8.897-7.385-10.392zM25.78 27h-2.107l-.117.007a1 1 0 00-.883.993l-.001 10.379-2.947-2.948-.094-.083a1 1 0 00-1.32.083l-1.49 1.49-.083.095a1 1 0 00.083 1.32l7.07 7.07.095.084a1 1 0 001.32-.083l7.299-7.299.083-.094a1 1 0 00-.084-1.32L31.19 35.28l-.094-.084a1 1 0 00-1.32.084l-2.997 2.998V28l-.006-.117A1 1 0 0025.78 27z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudDownload',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
